import React from "react";
import ServicesPresenter from "./ServicesPresenter";

const ServicesContainer = () => {
  return <ServicesPresenter />;
};

export default ServicesContainer;
